import { render, staticRenderFns } from "./TenantDeleteDialog.vue?vue&type=template&id=410ee01a&scoped=true"
import script from "./TenantDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./TenantDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./TenantDeleteDialog.vue?vue&type=style&index=0&id=410ee01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410ee01a",
  null
  
)

export default component.exports